export function parseDate(date) {
  return date < 10 ? `0${date}` : date;
}

export const getProperDate = (date) => (date ? `${date.getFullYear()}`.padStart(2, '0') + '-' + `${date.getMonth() + 1}`.padStart(2, '0') + '-' + `${date.getDate()}`.padStart(2, '0') : null);

export function getTime(date, time) {
  if (!date || !time) {
    return;
  }

  
  const year = date.getFullYear();
  const month = parseDate(date.getMonth());
  const day = parseDate(date.getDate());
  
  const hour = time.slice(0, 2);
  const minute = time.slice(3, 5);
  
  // const dateTime = `${year}-${month}-${day}T${hour}:${minute}:00Z`;
  const dateTime = new Date(year, month, day, hour, minute);
  
  return dateTime;
}

export function getMonthString(number) {
  const month = [
    "Января",
    "Февраля",
    "Марта",
    "Апреля",
    "Мая",
    "Июня",
    "Июля",
    "Августа",
    "Сентября",
    "Октября",
    "Ноября",
    "Декабря",
  ]
  return month[number]
}

export const checkDayToDay = (date) => {
  if(date === '' || date === null) {
    return
  }
  const selectedDay = new Date(getStringDate(date));
  selectedDay.setDate(selectedDay.getDate() + 1);
  return getStringDate(new Date()) === getStringDate(selectedDay);
};

const getStringDate = (date) => date.toISOString().slice(0, 10);